export default "__VITE_ASSET__88b55cb1__"